import Vue from 'vue';
import Router from 'vue-router';
import paths from './paths';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

Vue.use(Router);

const router =  new Router({
  base: '/',
  mode: 'hash',
  linkActiveClass: 'active',
  routes: paths
});
// router gards
router.beforeEach((to, from, next) => {
  
  /*if (router.currentRoute.path != '/404' && router.currentRoute.path != '/403' && router.currentRoute.path != '/500' && router.currentRoute.path != '/login') {
    localStorage.lastVisitedPage = router.currentRoute.path;
  }*/

  if (to.path != '/404' && to.path != '/403' && to.path != '/500' && to.path != '/login') {
    localStorage.lastVisitedPage = to.path;
  }

  NProgress.start();
  next();
});

router.afterEach((to, from) => {
  // ...
  NProgress.done();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js